import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  freightLanes: 'FreightLanes',
  freightLaneLocations: 'FreightLaneLocations',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.freightLanes, TAG_TYPES.freightLaneLocations],
  endpoints: {
    getFreightLanes: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(freightLane => ({
                type: TAG_TYPES.freightLanes,
                id: freightLane.id,
              })),
              { type: TAG_TYPES.freightLanes, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'FreightLanes', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.freightLanes, id: 'LIST' }],
    },
    getFreightLane: {
      providesTags: (result, error, { id }) => [{ type: TAG_TYPES.freightLanes, id }],
    },
    createFreightLane: {
      invalidatesTags: [
        { type: TAG_TYPES.freightLanes, id: 'LIST' },
        { type: TAG_TYPES.freightLaneLocations, id: 'LIST' },
      ],
    },
    updateFreightLane: {
      invalidatesTags: (result, error, { id }) => [{ type: TAG_TYPES.freightLanes, id }],
    },
    getFreightLaneLocations: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(freightLaneLocation => ({
                type: TAG_TYPES.freightLaneLocations,
                id: freightLaneLocation.id,
              })),
              { type: TAG_TYPES.freightLaneLocations, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'FreightLanes', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.freightLaneLocations, id: 'LIST' }],
    },
    createFreightLaneLocation: {
      invalidatesTags: [{ type: TAG_TYPES.freightLaneLocations, id: 'LIST' }],
    },
    updateFreightLaneLocation: {
      invalidatesTags: (result, error, { id }) => [{ type: TAG_TYPES.freightLaneLocations, id }],
    },
    getFreightLanePrices: {
      providesTags: (result, error, { id }) => [{ type: TAG_TYPES.freightLanes, id }],
    },
    updateFreightLanePrices: {
      invalidatesTags: (result, error, { id }) => [{ type: TAG_TYPES.freightLanes, id }],
    },
  },
})

export const {
  useGetFreightLanesQuery,
  useGetFreightLaneQuery,
  useCreateFreightLaneMutation,
  useUpdateFreightLaneMutation,
  useGetFreightLaneLocationsQuery,
  useCreateFreightLaneLocationMutation,
  useUpdateFreightLaneLocationMudation,
  useGetFreightLanePricesQuery,
  useUpdateFreightLanePricesMutation,
} = api
